export function registerServiceWorker() {
  if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((registration) => {
          // Check for updates every time the page loads
          registration.update();

          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'activated') {
                  // New SW activated — reload to pick up latest code
                  window.location.reload();
                }
              });
            }
          });
        })
        .catch((err) => {
          console.error('SW registration failed:', err);
        });
    });
  }
}
